import React, { useEffect, useState } from "react";
import Api from "../../Hooks/Api";
import { Link } from "react-router-dom";
import Table from "./../../Components/Table";
const AuditTrails = (props) => {
  const [RowData, setRowData] = useState([]);
  const url = "api/auditTrail";
  const convertTimestampToDate = (timeStamp) => {
    return new Date(timeStamp).toLocaleDateString("en-US");
  };
  const columns = [
    { label: "Action", field: "action", sort: "asc" },
    { label: "Description", field: "description", sort: "asc" },
    { label: "User", field: "username", sort: "asc" },
    { label: "Created At", field: "createdAt", sort: "asc" },
  ];
  const setAuditTrailsData = async (data) => {
    const rows = data?.trails || [];

    rows.forEach((k) => {
      const Rowdata = {
        id: k.id,
        action: k.action,
        description: k.description,
        username: k.username,
        createdAt: convertTimestampToDate(k.createdAt),
      };
      setRowData((inputs) => [...inputs, Rowdata]);
    });
  };
  const FetchAll = async () => {
    setRowData([]);
    try {
      Api.get(url + "/getAll?page=0&size=10")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setAuditTrailsData(data);
            const totalPages = data.totalPages;
            for (let i = 0; i < totalPages; i++) {
              let nextPage = parseFloat(i) + parseFloat(1);
              Api.get(url + "/getAll?page=" + nextPage + "&size=10")
                .then(function (response) {
                  if (response.status === 200) {
                    const data = response.data;
                    setAuditTrailsData(data);
                  }
                })
                .catch(function (error) {})
                .then(function () {
                  // always executed
                });
            }
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
  }, []);
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Audit Trails</li>
      </ol>
      <h1 class="page-header mb-3">Audit Trails</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={RowData} columns={columns} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AuditTrails;
